import { useEffect } from "react";
import { selectCommunicationData } from "../../store";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { Vspace } from '../../components/styled/Separators.style'
import PageContainerCmp from "../PageContainerCmp";
import { saveCommunicationAct } from "../../store/communication-data/actions";
import { CommunicationType, EventCommType, EventValueEnum } from "../../types/communication/communicationDataType";
import { LINEAR_BASE_ROUTE, LINEAR_PATHS } from "../../routes/linearRouteConstants";
import { LQuestionText } from "../../components/styled/Text.style";
import { LNextButton } from "../../components/styled/Button.style";
import { LButtonContainer, Section, LVerticalSection } from "../../components/styled/Containers.style";
import LinearFooterCmp from "../../components/footer/LinearFooter";
import { composeUrl } from "../../utils/utils";
import { useNavigate } from "react-router-dom";
import { CaiSideType, SignCaiBodyType } from "../../types/communication/sign-type";
import SinistroCardLinear from "../../components/cards/SinistroCardLinear";

/* istanbul ignore next */
const WelcomePageLinear = () => {

    const dispatch = useAppDispatch();
    const communicationData = useAppSelector(selectCommunicationData)
    const navigate = useNavigate();
    const { communication } = communicationData
    const { token, caiData, forceLastPathname } = communication;
    let telNumberDriverA = caiData?.data.vehicleA?.driver.telNumber

    useEffect(() => {
        const newEvent = new EventCommType({ value: EventValueEnum.LINEAR_COMMUNICATION_OPENED });
        const newEvent2 = new EventCommType({ value: EventValueEnum.LINEAR_DRIVER_QUESTION_SHOW });
        dispatch(saveCommunicationAct({
            events: [newEvent, newEvent2],
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        const urlParams = new URLSearchParams(window?.location?.search || '')
        const isDriverContext = urlParams.get('driver') === 'true'
        if (forceLastPathname?.includes("driver=true") && !isDriverContext) {
            let _path = LINEAR_PATHS.END_TO_DRIVER_THANK_YOU_PAGE
            const _pathname = composeUrl(token, _path, LINEAR_BASE_ROUTE)
            navigate(_pathname)
        }
        else if (telNumberDriverA) {
            let _path = LINEAR_PATHS.CAI_PRESENTATION_PAGE
            const _pathname = composeUrl(token, _path, LINEAR_BASE_ROUTE)
            navigate(_pathname)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [telNumberDriverA])

    const goToNextStepHandler = (answerInsuredIsDriver: boolean) => {
        const isDriver = answerInsuredIsDriver;
        const basePath = LINEAR_BASE_ROUTE;
        const resendPath = composeUrl(token, LINEAR_PATHS.RESEND_COMMUNICATION_PAGE, basePath);
        const caiPresentationPath = composeUrl(token, LINEAR_PATHS.CAI_PRESENTATION_PAGE, basePath);

        const updatedLinearConducenteInfo = {
            ...communication.linearConducenteInfo,
            insuredIsDriver: answerInsuredIsDriver
        };

        const uptData = new CommunicationType({
            ...communication,
            linearConducenteInfo: updatedLinearConducenteInfo
        });

        if (!isDriver) {
            const newEvent = new EventCommType({
                value: EventValueEnum.LINEAR_DRIVER_STATEMENT_REJECTED
            });
            dispatch(saveCommunicationAct({
                data: uptData,
                events: [newEvent],
                callback: () => navigate(resendPath)
            }));
        } else {
            // Se il conducente è l'assicurato
            const vehicleA: CaiSideType = {
                ...communication?.caiData?.data?.vehicleA!,
                driver: communication?.caiData?.data?.vehicleA?.insured!
            };
            const updatedCaiData: SignCaiBodyType = {
                ...communication?.caiData!,
                data: {
                    ...communication?.caiData?.data,
                    vehicleA
                }
            };
            const yesEvent = new EventCommType({
                value: EventValueEnum.LINEAR_DRIVER_ANSWER_Y
            });

            dispatch(saveCommunicationAct({
                data: new CommunicationType({
                    ...uptData,
                    caiData: updatedCaiData
                }),
                events: [yesEvent],
                callback: () => navigate(caiPresentationPath)
            }));
        }
    };


    return (
        <>

            <PageContainerCmp
                routePath={LINEAR_PATHS.WELCOME_FIRST_PAGE}
                removeNextBtn
                isForceLastPathname={true}
            >

                <SinistroCardLinear />

                <Section linear={true}>
                    <LVerticalSection className="question">
                        <LQuestionText>Eri conducente al momento del sinistro?</LQuestionText>

                        <Vspace qty={4}></Vspace>

                        <LButtonContainer>
                            <LNextButton onClick={() => goToNextStepHandler(true)}>Sì</LNextButton>
                            <LNextButton onClick={() => goToNextStepHandler(false)}>NO</LNextButton>
                        </LButtonContainer>

                    </LVerticalSection>

                </Section>

                <LinearFooterCmp />

            </PageContainerCmp>
        </>

    )
}

export default WelcomePageLinear